import React, { createContext, useContext, useMemo, useState } from 'react';
import { bundles, featuredBundle } from '../data/blackout';
import type { Bundle, BundleId } from '../types/blackout';
interface BundleContextValue {
  selected: Bundle;
  selectBundle: (id: BundleId) => void;
  showCrystalBonus: boolean;
}
const BundleContext = createContext<BundleContextValue | null>(null);
interface BundleProviderProps {
  children: React.ReactNode;
  showCrystalBonus: boolean;
}
export function BundleProvider({
  children,
  showCrystalBonus
}: BundleProviderProps) {
  // Triple Arc is the default recommendation, never the single mask.
  const [selectedId, setSelectedId] = useState<BundleId>(featuredBundle.id);
  const value = useMemo<BundleContextValue>(() => ({
    selected: bundles.find(b => b.id === selectedId) ?? featuredBundle,
    selectBundle: setSelectedId,
    showCrystalBonus
  }), [selectedId, showCrystalBonus]);
  return <BundleContext.Provider value={value} data-id="element-1970" data-mp="2hjzzja0ou2ob">{children}</BundleContext.Provider>;
}
export function useBundle() {
  const ctx = useContext(BundleContext);
  if (!ctx) throw new Error('useBundle must be used inside BundleProvider');
  return ctx;
}